import { applyMiddleware, combineReducers, compose, createStore, Middleware } from 'redux';
import { createLogger } from 'redux-logger';
import ravenMiddleware from 'redux-raven-middleware';
import reducer, { $$initialState } from '../ducks/Subscribe';
import { ISubscribeState } from '../models/SubscribeState';

export default (props: ISubscribeState) => {
  // reducer
  const combinedReducer = combineReducers({
    $$subscribeStore: reducer,
  });

  const middlewares: Middleware[] = [ravenMiddleware((window as any).raven)];
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(createLogger());
  }
  const devtools: any = process.env.NODE_ENV !== 'production' && (window as any).__REDUX_DEVTOOLS_EXTENSION__ ?
    (window as any).__REDUX_DEVTOOLS_EXTENSION__() : (f: any) => f;

  const { titles, newsTopics, selectedTitleId, selectedNewsTopicId } = props;

  const store = createStore(
    combinedReducer,
    {
      $$subscribeStore: $$initialState.merge({
        newsTopics: newsTopics,
        titles,
        selectedTitleId: selectedTitleId,
        selectedNewsTopicId: selectedNewsTopicId,
      }),
    },
    compose(
      applyMiddleware(...middlewares),
      devtools,
    ),
  );

  return store;
};
